import { render, staticRenderFns } from "./SideMenuToggle.vue?vue&type=template&id=3b9589e2&scoped=true&"
import script from "./SideMenuToggle.vue?vue&type=script&lang=js&"
export * from "./SideMenuToggle.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuToggle.vue?vue&type=style&index=0&id=3b9589e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9589e2",
  null
  
)

export default component.exports